import request from '../request'

export default {
  getImagenesRecurso(data) {
    return request.get(`recurso_imagen/${data}`)
  },
  setImagenesRecurso(data) {
    return request.post(`recurso_imagen/${data.ID_RECURSO}`, data.imagenes)
  },
  deleteRecursoImagen(data) {
    return request.delete(`recurso_imagen/${data.ID_RECURSO}/${data.ID_RECURSO_IMAGEN}`)
  }
}
